import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {RegistrationDataFilter} from './registrationData-filter/RegistrationDataFilter.js';
import {RegistrationDataTable} from './registrationData-table/RegistrationDataTable';
import {RegistrationDataFooter} from './registrationData-footer/RegistrationDataFooter';
import FooterBar from '../../_common/components/FooterBar';

export function RegistrationDataCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'reg-data-card'}>
      <RegistrationDataFilter/>
      <RegistrationDataTable/>
      <FooterBar>
        <RegistrationDataFooter/>
      </FooterBar>
    </Card>
  );
}
